import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DailyRacesService } from 'src/app/pages/daily-races/daily-races.service';
import { BonusApi } from '../../apis/bonus.api';
import { LayoutService } from '../../service/layout.service';
import { LocaleService } from '../../service/locale.service';
import { PaginatorState } from '../paginator/paginator.module';
@UntilDestroy()
@Component({
  selector: 'app-leader-board-popup',
  templateUrl: './leader-board-popup.component.html',
  styleUrls: ['./leader-board-popup.component.scss'],
})
export class LeaderBoardPopupComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    private localeService: LocaleService,
    private bounsApi: BonusApi,
    public dialogRef: MatDialogRef<LeaderBoardPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dailyRacesService: DailyRacesService,
  ) {}
  isH5!: boolean;
  // isFirst: boolean = true;
  /** 显示当前比赛 和 剩余时间 */
  topList: any[] = [];

  titleData: any = [
    // 0-有效流水
    {
      type: 0,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: this.localeService.getValue('gamer'),
        },
        {
          icon: 'icon-warning',
          text: this.localeService.getValue('nrg_format'),
          toolTips: this.localeService.getValue('race_tips'),
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 10-大赢家(总输赢)
    {
      type: 10,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: this.localeService.getValue('gamer'),
        },
        {
          icon: 'icon-warning',
          text: this.localeService.getValue('total_w_l'),
          toolTips: this.localeService.getValue('race_tips'),
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 11-大赢家(单笔最大盈利)
    {
      type: 11,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: this.localeService.getValue('gamer'),
        },
        {
          icon: 'icon-warning',
          text: this.localeService.getValue('maximum_profit_amount'), // 玩家,单笔最大盈利
          toolTips: this.localeService.getValue('race_tips'),
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 2-运气最好
    {
      type: 2,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: this.localeService.getValue('gamer'),
        },
        {
          icon: 'icon-warning',
          text: this.localeService.getValue('best_odds'),
          toolTips: this.localeService.getValue('race_tips'),
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
  ];
  selectedType!: number;
  /** 选择活动的当前下表 */
  selectedActivitIndex: number = 0;
  selectTitleData = this.titleData[this.selectedActivitIndex].titleArr;

  /** H5 分页 */
  paginator: PaginatorState = {
    page: 1,
    pageSize: 10,
    total: 0,
  };
  /** 排名数据 */
  rankList: any[] = [];
  /** loading */
  rankLoading: boolean = false;

  ngOnInit(): void {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isH5 = x;
      // 如果從H5變到web則會直接導首頁
    });
    this.selectedActivitIndex = this.data.index;
    this.getTitleList();
  }
  /**
   * 关闭弹窗
   */
  close() {
    this.dialogRef.close();
  }

  /** 获取活动 导航列表 */
  getTitleList() {
    this.dailyRacesService.getDailyTitles().subscribe(list => {
      this.topList = list?.title || [];
      if (this.topList.length > 0) {
        this.selectedType = this.topList[this.selectedActivitIndex].executeType;
        this.selectTitleData = this.titleData.find((x: any) => x.type == this.selectedType).titleArr;
        this.getRank();
      }
    });
  }

  /** 获取所有排名 */
  getRank() {
    this.rankLoading = true;
    const params = {
      activitiesNo: this.topList[this.selectedActivitIndex]?.activitiesNo || '',
      pageIndex: this.paginator.page,
      pageSize: this.paginator.pageSize,
    };
    this.bounsApi.getRank(params).subscribe(data => {
      this.rankLoading = false;
      if (data?.bonusInfo) {
        this.paginator.total = data?.total || 0;
        this.rankList = data.bonusInfo || [];
      } else {
        this.rankList = [];
      }
    });
  }
  /**
   * 选择对应活动
   *
   * @param idx
   * @param isFirst
   */
  onSelectAcivity(idx: number) {
    if (this.selectedActivitIndex === idx) return;
    this.paginator = {
      page: 1,
      pageSize: 10,
      total: 0,
    };
    this.selectedActivitIndex = idx;
    this.getRank();
  }
}
